<template>
  <b-container fluid class="gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4" align-self="center">
        <b-card>
          <div class="text-center">
            <img class="logo" src="/img/new-logo.svg" />
          </div>
          <h2 class="text-sm-center" v-if="!sent">Reset your password</h2>
          <p class="card-text text-sm-center" v-if="!sent">
            An email will be sent to you with all the necessary information to reset your password.
          </p>

          <b-form class="form" v-if="!sent">
            <b-form-group :invalid-feedback="emailError" :state="hasEmailError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="at" />
                </b-input-group-text>
                <b-form-input
                  v-model.trim="form.email"
                  placeholder="Email address"
                  required="required"
                  type="email"
                  name="email"
                  v-validate="'required|email'"
                  data-vv-validate-on="change|blur"
                  :state="hasEmailError"
                  size="lg"
                  v-focus
                  @keyup.native.enter="resetPassword"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-button size="lg" block variant="primary" @click="resetPassword">
                <strong>Reset</strong>
              </b-button>
            </b-form-group>
          </b-form>

          <h2 class="text-sm-center" v-if="sent">Check your inbox</h2>
          <p class="card-text text-sm-center" v-if="sent">
            If this account exists, you will receive an email with all the necessary information shortly.
          </p>

          <b-row slot="footer">
            <b-col class="text-center">
              <router-link :to="{ name: 'login' }">Login</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
const DEFAULT = {
  email: ''
}
export default {
  data: () => ({
    form: { ...DEFAULT },
    sent: false
  }),
  computed: {
    hasEmailError() {
      return this.fieldBag.email && this.fieldBag.email.dirty ? this.fieldBag.email.valid : null
    },
    emailError() {
      return this.errors.has('email') ? this.errors.first('email') : ''
    }
  },
  methods: {
    clearForm() {},
    resetPassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('reset-key', this.form.email)
          this.$store
            .dispatch('resetKey', this.form)
            .then(() => {})
            .catch(() => {})
          this.sent = true
        }
      })
    }
  }
}
</script>
